import React from 'react';
import List from '@mui/material/List';
import classNames from 'classnames';
import useCurrentUser from '@/lib/hooks/useCurrentUser';
import translate from '@/lib/intl/translate';
import { LayoutContext } from './LayoutProvider';
import NavigationHeader from './NavigationHeader';
import NavigationList from './NavigationList';
import ToggleSidebar from './ToggleSidebar';
import UserProfile from './UserProfile';

function Sidebar() {
  const { isSuperAdmin } = useCurrentUser();
  const { isExpanded, showHover, setShowHover } =
    React.useContext(LayoutContext);

  const handleMouseEnter = (event) => {
    /**
     * We need some special logic to capture when we are mousing
     * over the toggle button. If we are, prevent the call to setShowHover
     * Without this logic, mousing over the toggle button would cause
     * the sidebar to expand, creating an unpleasant experience for the
     * user.
     */
    const { target } = event;

    const isButton =
      target.parentElement.id === 'nav-expand-toggle-button' ||
      target.id === 'nav-expand-toggle-button';

    if (!isExpanded && !isButton) {
      setShowHover(true);
    }
  };

  return (
    <div className="relative" data-theme="v2">
      <div
        className={classNames(
          'transition-width fixed z-[999] flex w-0 flex-col border-r border-grey-300 bg-grey-100 duration-300 ease-out [grid-area:sidebar]',
          {
            'md:w-16': !(isExpanded || showHover),
            'md:w-[216px]': isExpanded || showHover,
            '[height:calc(100vh-64px)]': isSuperAdmin,
            'h-full': !isSuperAdmin,
          },
        )}
        onMouseEnter={handleMouseEnter}
        onMouseLeave={() => setShowHover(false)}
      >
        <div className="flex h-full flex-col">
          <div
            className={classNames('flex-auto overflow-x-hidden', {
              'overflow-y-auto': isExpanded || showHover,
              'overflow-y-hidden': !isExpanded && !showHover,
            })}
            onMouseEnter={handleMouseEnter}
          >
            <ToggleSidebar />
            <List
              aria-expanded={isExpanded}
              aria-label={translate('NAVIGATION_PRIMARY')}
              component="nav"
              disablePadding
            >
              <NavigationHeader />
              <NavigationList />
            </List>
          </div>
          <div
            className="overflow-hidden border-t border-grey-300"
            onMouseEnter={() => {
              if (!showHover) setShowHover(false);
            }}
          >
            <UserProfile />
          </div>
        </div>
      </div>
    </div>
  );
}

export default Sidebar;
